import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { userApi } from '../../services/user/userApi';
import { tokenRefreshed } from '../../services/api';

import { getCookie } from '../../../utils/cookies';

const userToken = getCookie('token') ? getCookie('token') : null;

const initialState = {
  user: null,
  token: userToken,
  isLoading: false,
  loginError: null,
  userInfo: null,
  userInfoError: null,
};

export const setUser = createAsyncThunk(
  'user/setUser',
  async payload => payload
);

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    logout: state => {
      state.token = null;
      state.userInfo = null;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(tokenRefreshed, (state, action) => {
        state.token = action.payload;
      })
      .addMatcher(userApi.endpoints.login.matchPending, (state, action) => {
        state.loginError = null;
      })
      .addMatcher(userApi.endpoints.login.matchFulfilled, (state, action) => {
        state.loginError = null;
        state.token = action.payload.access_token;
      })
      .addMatcher(userApi.endpoints.login.matchRejected, (state, action) => {
        state.loginError = action.payload;
      })

      .addMatcher(userApi.endpoints.logout.matchPending, (state, action) => {
        state.loginError = null;
      })
      .addMatcher(userApi.endpoints.logout.matchFulfilled, (state, action) => {
        state.loginError = null;
        state.token = null;
        state.userInfo = null;
      })
      .addMatcher(userApi.endpoints.logout.matchRejected, (state, action) => {
        state.loginError = action.payload;
        // Force logout even if API call fails
        state.token = null;
        state.userInfo = null;
      })

      .addMatcher(
        userApi.endpoints.getUserInfo.matchFulfilled,
        (state, action) => {
          state.userInfoError = null;
          state.userInfo = action.payload;
        }
      )
      .addMatcher(
        userApi.endpoints.getUserInfo.matchRejected,
        (state, action) => {
          state.userInfoError = action.payload;
        }
      );
  },
});

export const { logout } = userSlice.actions;
export default userSlice.reducer;
